import { createModel } from "@rematch/core";
import { CustomerGroupListItem } from "src/lib/models/CustomerGroupListItem";

import { RootModel } from ".";

const initialState: CustomerGroupListItem | null = null;

export const activeCustomerGroup = createModel<RootModel>()({
  state: initialState as CustomerGroupListItem | null,
  reducers: {
    setActiveCustomerGroup(state, payload: CustomerGroupListItem | null) {
      return payload;
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/activeCustomerGroup.ts